module.exports = __webpack_public_path__ + "static/media/Matthew Burness.2ebedf8a.png";